import "./broadcast.css";
import React from "react";
import BroadcastIcon from "../../Asset/Images/broadcast-icon.svg";
import strings from "../../utils/property-file/broadcast.json";
import { useNavigate } from "react-router-dom";
import constants from "../../utils/constants";
import { useEffect, useState } from "react";
import GroupEmployee from "../../Asset/Images/employee-group-icon.svg"
import SingleCheck from "../../Asset/Images/single-check-icon.svg"
import PhoneIcon from "../../Asset/Images/mobile-icon.svg"
import WriteIcon from "../../Asset/Images/write-icon.svg"
import api from "../../services/api";
import moment from "moment";
import { toast } from "react-toastify";
import SpinnerButton from "../button/spinnerButton";
import SelectedUSerIcon from "../../Asset/Images/selected-user-icon.svg"
import ReadIcon from "../../Asset/Images/read-icon.svg";

export default function BroadCast() {
    const nav = useNavigate();
    const [broadcastHistory , setBroadcastHistory] = useState([]);
    const [fetchingBroadcast , setFetchingBroadcast] = useState(true);
    const getBroadcast = async () =>{
        try {
            const response = await api.getBroadcastHistory();
            if(response && response.data){
                const data = JSON.parse(response.data);
                if(response.success) {
                    setBroadcastHistory(data.body);
                }
                else {
                    setBroadcastHistory([]);
                }
            }
            setFetchingBroadcast(false);
        }
        catch(error) {
            setFetchingBroadcast(false);
            toast.error(strings.somethingWentWrong , {toastId : strings.errorCode})
            setBroadcastHistory([]);
        }
    }
    useEffect(()=>{
        getBroadcast();
    },[])

    return(
        <div className="main-container-of-broadcast">
       {fetchingBroadcast ? <div className="loader-for-broadcast"><SpinnerButton/></div> : <>
       {broadcastHistory.length>0 ?
             <div className="sub-container-of-broadcast history-of-broadcast">
                 <div className="list-of-broadcast-container-header">
                     <div className="list-container-string">
                        {strings.broadcastList}
                     </div>
                     <div className="list-container-button-create-broadcast">
                         <button onClick={(()=>{nav(constants.navigationLink.createBroadCast)})}>{strings.newBroadcast}</button>
                     </div>
                 </div>
                 {broadcastHistory.length>0 ? broadcastHistory.map((key,index)=>{
                     return (
                         <div className="history-of-broadcast-list" key={index}>
                     <div className="date-divider-of-broadcast ">
                         <div className="divider-line"></div>
                         <div className="date-of-broadcast">
                             <div className="created-broadcast-date">
                             {moment(key._id).format(strings.dateFormat)}
                             </div>
                         </div>
                     </div>
                     {key.documents && key.documents.length>0  ?
                     key.documents.map((newKey,newIndex)=>{
                        return(
                         <div className="broadcast-container-data" key={newIndex} onClick={(()=>{
                            localStorage.setItem("broadcastId", newKey._id)
                            localStorage.setItem("broadcasterName" , newKey.sentBy)
                            nav(constants.navigationLink.detailBroadcast)}
                            )}>
                         <div className="broadcast-status-with-name">
                             <span className="name-of-broadcast">{newKey.title} </span>
                             {newKey.allIsRead ?  <span className="status-icon-broadcast"><img src={ReadIcon} alt="icon-check" /></span> : <span className="status-icon-broadcast"><img src={SingleCheck} alt="icon-check" /></span>}
                         </div>
                         <div className="content-of-created-broadcast">
                             {newKey.content}
                         </div>
                         <div className="footer-of-broadcast">
                             <div>{newKey.all ? <div className="broadcast-reachability-details"><img src={GroupEmployee} alt="image-emp" /><div>{strings.allEmployee}</div></div>:<div className="broadcast-reachability-details"><img src={SelectedUSerIcon} alt="image-emp" /><div>{strings.selectedEmployee}</div></div>}</div>
                             <div className="right-side-option-broadcast-list">
                                 <div className="icon-of-broadcast-type">
                                     <img src={PhoneIcon} alt="icon-phone" />
                                     {newKey.type}
                                 </div>
                                 <div className="icon-of-broadcast-sender">
                                     <img src={WriteIcon} alt="icon-edit" />
                                     {newKey.sentBy}
                                 </div>
                                 <div>
                                 {moment(newKey.createdDate).format(strings.timeFormat)}
                                 </div>
                             </div>
                         </div>
                     </div>
                        )
                     }) :null
                     }
                     
                 </div>
                     )
                 }):null}
             </div>: <div className="sub-container-of-broadcast">
                 <div className="broadcast-logo"><img src={BroadcastIcon} alt="broadcast-icon" /></div>
                 <div className="broadcast-message">{strings.noBroadcast}</div>
                 <div className="broadcast-button"><button onClick={(()=>{ nav(constants.navigationLink.createBroadCast)})}>{strings.broadcastNow}</button></div>
                 <div className="broadcast-button-media-query"><button ><img src={BroadcastIcon} alt="icon-broadcast" className="button-broadcast-icon" /></button></div>
             </div>
         } 
       </>} 
        </div>
    )
}